/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, useMemo } from "react"
import { RegisterOptions, useFormContext } from "react-hook-form"
import { iChangeType } from "../../../definitions/interfaces"

interface iInputProps {
  name: string
  label?: string
  type?: "text" | "checkbox" | "number"
  placeholder?: string
  validation?: RegisterOptions
  autoComplete?: "off" | "on"
  onChange?: ({ name, value }: iChangeType) => void
}

const FormInput: FunctionComponent<iInputProps> = ({
  name,
  label = "",
  placeholder,
  type = "text",
  validation = {},
  autoComplete = "on",
  onChange,
}) => {
  const { register, errors } = useFormContext()

  const parsedError = useMemo(() => {
    if (!errors) return null
    if (name.includes(".")) {
      const names = name.split(".")
      let val = errors
      names.forEach((n) => {
        if (val) val = val[n]
      })
      return val
    }
    return errors[name]
  }, [errors, name])

  const isError = useMemo(() => !!parsedError, [parsedError])

  return (
    <div className={`form-group ${type === "checkbox" ? "checkbox-wrap" : ""}`}>
      {(label || parsedError) && (
        <label htmlFor={name}>
          {label}
          {parsedError && <span>{parsedError.message}</span>}
        </label>
      )}
      <div className="form-control">
        <input
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          ref={register({ valueAsNumber: type === "number", ...validation })}
          // {...register(name, { validate: validation })}
          autoComplete={autoComplete}
          className={isError ? "error" : ""}
          onChange={(e) => {
            onChange &&
              onChange({
                name,
                value:
                  type === "text"
                    ? e.target.value
                    : type === "number"
                    ? e.target.valueAsNumber
                    : e.target.checked,
              })
          }}
        />
      </div>
    </div>
  )
}

export default FormInput
